import React, { useState } from 'react';
import { MessageSquare, Trash2, Plus, User } from 'lucide-react';
import Button from '../../../ui-kit/Button';
import { CustomerService } from '../services/CustomerService';
import { formatDate } from '../../../shared/utils/formatters';

const RemarksSection = ({ mobile, remarks = [], onUpdate }) => {
    const [newRemark, setNewRemark] = useState('');
    const [loading, setLoading] = useState(false);

    const handleAdd = async () => {
        if (!newRemark.trim()) return;
        setLoading(true);
        try {
            await CustomerService.addRemark(mobile, {
                text: newRemark,
                createdBy: 'Admin' // Replace with actual user
            });
            setNewRemark('');
            onUpdate(); // Refresh parent
        } catch (error) {
            console.error("Failed to add remark", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        // if (!window.confirm("Delete this remark?")) return;
        try {
            await CustomerService.deleteRemark(mobile, id);
            onUpdate();
        } catch (error) {
            console.error("Failed to delete remark", error);
        }
    };

    // Convert object to array if needed
    const remarksList = Array.isArray(remarks) ? remarks : Object.entries(remarks || {}).map(([key, val]) => ({ id: key, ...val }));
    // Sort by date desc
    remarksList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100">
            <div className="flex items-center gap-2 mb-4 pb-2 border-b border-slate-50">
                <MessageSquare size={18} className="text-purple-600" />
                <h3 className="font-bold text-slate-800">Customer Remarks</h3>
            </div>

            <div className="space-y-4 mb-6 max-h-60 overflow-y-auto pr-2">
                {remarksList.length === 0 ? (
                    <p className="text-sm text-slate-400 text-center py-4">No remarks yet.</p>
                ) : (
                    remarksList.map((remark) => (
                        <div key={remark.id || Math.random()} className="bg-slate-50 p-3 rounded-lg border border-slate-100 relative group">
                            <div className="flex justify-between items-start">
                                <p className="text-sm text-slate-700">{remark.text}</p>
                                <button
                                    onClick={() => handleDelete(remark.id)}
                                    className="text-slate-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                                >
                                    <Trash2 size={14} />
                                </button>
                            </div>
                            <div className="flex items-center gap-2 mt-2 text-xs text-slate-400">
                                <User size={12} />
                                <span>{remark.createdBy || 'System'}</span>
                                <span>•</span>
                                <span>{remark.createdAt ? formatDate(remark.createdAt) : 'Unknown Date'}</span>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <div className="flex gap-2">
                <input
                    type="text"
                    placeholder="Add a note..."
                    className="flex-1 px-3 py-2 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-purple-100"
                    value={newRemark}
                    onChange={(e) => setNewRemark(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                />
                <Button onClick={handleAdd} disabled={loading} icon={Plus}>Add</Button>
            </div>
        </div>
    );
};

export default RemarksSection;
